//Document ready
$(function () {
  if (window.matchMedia("(min-width: 36em)").matches) {
    priceHeight();
  }
});


window.addEventListener("resize", function () {
  var products = document.querySelectorAll(".product"),
    i;
  //Phone portrait - up to 575px
  if (window.matchMedia("(max-width: 35.938em)").matches) {
    for (i = 0; i < products.length; i++) {
      products[i].classList.remove("discount-on-line");
    }
  }

  //Phone from 576px up
  if (window.matchMedia("(min-width: 75em)").matches) {}
  if (window.matchMedia("(min-width: 36em)").matches) {
    priceHeight();
  }

});



//Init filter checkbox
function priceHeight() {


  var products = document.querySelectorAll(".product"),
    productHaveClass = false,
    i,
    x;

  if (products.length === 0) {
    return
  }

  if (products[0].classList.contains("col-lg-4")) {
    x = 3;
  } else {
    x = 4;
  }


  //Up to tablet portrait - up to 991px
  if (window.matchMedia("(max-width: 61.938em)").matches) {
    x = 2;
  }


  for (i = 0; i < products.length; i = i + x) {
    productHaveClass = false;

    if (products[i].classList.contains("discount-price")) {
      productHaveClass = true;
    } else if (products[i + 1] && products[i + 1].classList.contains("discount-price")) {
      productHaveClass = true;
    }
    if (x === 3 && products[i + 2] && products[i + 2].classList.contains("discount-price")) {
      productHaveClass = true;
    }

    if (x === 4 && products[i + 3] && products[i + 3].classList.contains("discount-price")) {
      productHaveClass = true;
    }
    if (productHaveClass === true) {


      products[i].classList.add("discount-on-line");
      if (products[i + 1]) {
        products[i + 1].classList.add("discount-on-line");
      }
      if (x === 3 && products[i + 2]) {
        products[i + 2].classList.add("discount-on-line");
      }

      if (x === 4 && products[i + 3]) {
        products[i + 3].classList.add("discount-on-line");
      }

    }

  }

}